import { render, staticRenderFns } from "./DashboardFaturamento.vue?vue&type=template&id=02aff5ac&scoped=true"
import script from "./DashboardFaturamento.vue?vue&type=script&lang=js"
export * from "./DashboardFaturamento.vue?vue&type=script&lang=js"
import style0 from "./DashboardFaturamento.vue?vue&type=style&index=0&id=02aff5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aff5ac",
  null
  
)

export default component.exports